import { education } from "../data/education";
import { experience } from "../data/experience";
import { SectionHeading } from "./SectionHeading";
import { Timeline } from "./Timeline";

export function ExperienceEducation() {
  return (
    <section id="experience" className="section shell">
      <SectionHeading
        number="04"
        eyebrow="Experience / education"
        title="A practice shaped by work and research."
        description="Application engineering, data migration, academic systems work and hands-on robotics."
      />
      <div className="dual-timeline">
        <div>
          <div className="subsection-title"><span>A</span><h3>Professional experience</h3></div>
          <Timeline items={experience} ariaLabel="Professional experience timeline" />
        </div>
        <div>
          <div className="subsection-title"><span>B</span><h3>Education</h3></div>
          <Timeline items={education} ariaLabel="Education timeline" />
        </div>
      </div>
    </section>
  );
}
